import { render, staticRenderFns } from "./WorkDetails.vue?vue&type=template&id=641a4e6d&scoped=true"
import script from "./WorkDetails.vue?vue&type=script&lang=js"
export * from "./WorkDetails.vue?vue&type=script&lang=js"
import style0 from "./WorkDetails.vue?vue&type=style&index=0&id=641a4e6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641a4e6d",
  null
  
)

export default component.exports